import { useContext } from 'react';

import CalculatorContext from 'src/pages/Profession/components/SectionCalculator/Context/CalculatorContext';
import { CalculatorContextState } from 'src/pages/Profession/components/SectionCalculator/Context/types';

const useCalculatorContext = (): CalculatorContextState => {
    return useContext(CalculatorContext) as CalculatorContextState;
};

export default useCalculatorContext;
